import { useLiveQuery } from 'dexie-react-hooks';
import { db, type CachedStoryRow } from '../../db/schema';

/**
 * Nombre de stories non vues — alimente l'anneau. Requête d'index pure :
 * « c'est vu » écrit toujours `seen: 1`, donc pas besoin de filtrer `state`
 * (un `.filter()` ici lirait toute la table à chaque émission).
 */
export function useUnseenStoriesCount(): number {
  return useLiveQuery(() => db.stories.where('seen').equals(0).count(), []) ?? 0;
}

/** Tri du vendeur : « rappelle-le-moi » (mise de côté), « c'est vu », ou retour à l'état actif. */
export async function setStoryState(id: string, state: CachedStoryRow['state'] | null): Promise<void> {
  await db.stories.update(id, { state: state ?? undefined, seen: 1 });
}

/**
 * Nombre de stories en cache, vues ou non. Sert de preuve HORS LIGNE que le
 * Fil est ouvert à ce rôle : la table n'est peuplée que si l'API a répondu,
 * et vidée sur 403. Sans ce repli, l'entrée disparaîtrait au démarrage à
 * froid sans réseau alors que Dexie a tout ce qu'il faut.
 */
export function useStoriesCount(): number {
  return useLiveQuery(() => db.stories.count(), []) ?? 0;
}

/** Toutes les stories en cache, de la plus récente à la plus ancienne. */
export function useStories(): CachedStoryRow[] | undefined {
  return useLiveQuery(() => db.stories.orderBy('at').reverse().toArray(), []);
}

/**
 * Marque des stories comme vues. État LOCAL en v1 : un changement de
 * téléphone rejoue les stories de la semaine, ce qu'on accepte.
 */
export async function markStoriesSeen(ids: string[]): Promise<void> {
  if (ids.length === 0) return;
  await db.stories.where('id').anyOf(ids).modify({ seen: 1 });
}
